import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            padre_id: data.padre_id,
        });
    }

    ResetForm() {
        this.setState({
            padre_id: null,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.subgrupos.delete}
                postUrl={api.usuarios.subgrupos.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Subgrupo ha sido eliminado con éxito."}
                notAllowedMessage={"El Subgrupo no puede ser eliminado ya que se encuentra en uso por Usuarios del sistema."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Subgrupo"}
                buttonTitle={"Eliminar Subgrupo"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                closeButton={true}
                danger={true}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Abreviatura</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="abreviatura" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Email</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="mail" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Teléfono</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="telefono" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Grupo</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker
                            disabled={true}
                            fieldName=""
                            url={api.usuarios.grupos.select}
                            onChange={(data) => this.setState({ padre_id: (data != null ? data.pk : 0) })}
                            value={this.state.padre_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Subgrupos/Delete.js